import { useStatusOverlay } from '@fs/zion-ui'
import { useCallback } from 'react'
import { deepCopy } from '../util/Utils'

export default function useNotifications() {
  const showStatusOverlay = useStatusOverlay()

  const log = (message, type, actionLabel, actionCallback, dismissable = false, transient = false) => {
    let statusProps = {
      message,
      type,
      dismissable,
      transient,
    }
    if (actionLabel && actionCallback) {
      statusProps = { ...statusProps, actionLabel, actionCallback }
    }

    showStatusOverlay(statusProps)
  }

  const error = useCallback(
    (message, err) => {
      if (err?.response?.data?.notifications) {
        message = `${message} ${err.response.data.notifications.map((notification) => notification.msg).join(' ')}`
      }
      log(message, 'error', null, null, true, false)
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  const warn = useCallback((message) => {
    log(message, 'warning', null, null, false, false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const info = useCallback((message) => {
    log(message, 'normal')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const ok = useCallback((message) => {
    log(message, 'success')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const serverTypeToLogger = (serverType) => {
    if (serverType === 'info') {
      return info
    }
    if (serverType === 'warn') {
      return warn
    }
    if (serverType === 'error') {
      return error
    }
    if (serverType === 'success') {
      return ok
    }
    return null
  }

  const showServerNotifications = useCallback((notifications, type = 'error') => {
    if (notifications) {
      // type comes from dmc-server/src/main/java/org/familysearch/dmcserver/schema/Notification.java
      type = type.toLowerCase()
      deepCopy(notifications).forEach((notification) => {
        if (notification.level.toLowerCase().includes(type)) {
          const logger = serverTypeToLogger(type)
          logger(`${notification.title} ${notification.msg}`)
        }
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    error,
    warn,
    info,
    ok,
    showServerNotifications,
  }
}
